import React, { useEffect } from "react";
import { CustomPaymentTextField } from "../../elements/TextField/TextField";
import { PaymentFormWrapper } from "../../../CompanyForm.styled";
import Grid from "@mui/material/Grid2";
export default function PaymentInfoForm({
  formData,
  setFormData,
  accountNameError,
  bsbError,
  accountNumberError,
  paymentDetails,
}) {

  useEffect(() => {
    // If paymentDetails is available and contains account information, update formData
    // Only update if at least one account field has a value to avoid clearing user input
    if (paymentDetails && (paymentDetails.accountName || paymentDetails.accountBSB || paymentDetails.accountNumber)) {
      setFormData((prevState) => ({
        ...prevState,
        accountName: paymentDetails.accountName || "",
        accountBSB: paymentDetails.accountBSB || "",
        accountNumber: paymentDetails.accountNumber || "",
      }));
    }
  }, [paymentDetails, setFormData]);

  const handleAccountNameChange = (e) => {
    const value = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      accountName: value,
    }));
  };

  const handleBsbChange = (e) => {
    const value = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      accountBSB: value,
    }));
  };
  
  const handleAccountNumberChange = (e) => {
    const value = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      accountNumber: value,
    }));
  };

  return (
    <PaymentFormWrapper>
      <Grid container spacing={4}>
        {/* Company Name Field */}
        <Grid size={{ xs: 12 }}>
          <CustomPaymentTextField
            fullWidth={true}
            label="Company name of account*"
            type="text"
            variant="outlined"
            name="accountName"
            value={formData.accountName}
            onChange={handleAccountNameChange}
            error={!!accountNameError}
            helperText={accountNameError}
            autoComplete="off"
          />
        </Grid>

        {/* BSB Field */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <CustomPaymentTextField
            fullWidth={true}
            required
            label="BSB"
            variant="outlined"
            name="accountBsb"
            value={formData.accountBSB}
            onChange={handleBsbChange}
            error={!!bsbError}
            helperText={bsbError}
            autoComplete="off"
          />
        </Grid>

        {/* Account Number Field */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <CustomPaymentTextField
            fullWidth={true}
            required
            label="Account Number"
            variant="outlined"
            name="accountNumber"
            value={formData.accountNumber}
            onChange={handleAccountNumberChange}
            error={!!accountNumberError}
            helperText={accountNumberError}
            autoComplete="off"
          />
        </Grid>
      </Grid>
    </PaymentFormWrapper>
  );
}
